import React, { useState } from 'react';
import styles from './DashboardOnvif.module.scss';
import { Modal } from '@/components/atomics';
import ActionsConfirm from '@/components/molecules/Actions/Confirm';
import { SERVICES } from '@/configs';
import { getLocalStorage } from '@/utils/storages';
import axios from 'axios';

interface IOSSwitchProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: () => void;
  disabled?: boolean;
  label?: React.ReactNode;
  userId?: string;
  className?: string;
  name?: string;
  [key: string]: any;
}

const DashboardOnvif: React.FC<IOSSwitchProps> = ({
  checked,
  defaultChecked,
  onChange,
  userId,
  disabled = false,
  label,
  className = '',
  name,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(
    checked !== undefined ? checked : defaultChecked || false
  );
  const [contentModal, setContentModal] = useState<React.ReactNode>(null);

  const handleConfirm = async (checked: boolean) => {
    const options = {
      url: SERVICES.ONVIF_ENABLE,
      method: 'PUT',
      data: {
        userId,
        onvif_eligible: checked
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getLocalStorage('access_token')}`
      }
    };

    await axios(options)
      .then((res) => {
        if (res?.data?.code === 200) {
          if (onChange) {
            setContentModal(undefined);
            onChange();
          }
        } else {
          console.error('Failed to update ONVIF status:', res?.data?.message);
        }
      })
      .catch((error) => {
        console.error('Error updating ONVIF status:', error);
      });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContentModal(
      <Modal close={false} open={true} onClose={() => setContentModal(undefined)}>
        <ActionsConfirm
          confirmTitle={checked ? 'Ya, Nonaktifkan' : 'Ya, Aktifkan'}
          title={checked ? 'Nonaktifkan Fitur ONFIV?' : 'Aktifkan Fitur ONFIV?'}
          message={checked ? 'Fitur ini tidak akan tersedia di aplikasi Eazy pelanggan dan tidak dapat diaktifkan maupun dikendalikan oleh pelanggan. Nonaktifkan fitur ONFIV?'
            : 'Fitur ini akan tersedia di aplikasi Eazy pelanggan dan dapat diaktifkan serta dikendalikan sepenuhnya oleh pelanggan, aktifkan fitur ONFIV?'}
          onConfirm={handleConfirm.bind(null, event.target.checked)}
          onCancel={() => setContentModal(undefined)}
        />
      </Modal>
    );
  };

  const switchChecked = checked !== undefined ? checked : isChecked;

  return (
    <div className={`${styles.switchContainer} ${className}`}>      
      <label className={styles.switchLabel}>
        <span className={styles.switchTrack}>
          <input
            type="checkbox"
            checked={switchChecked}
            onChange={handleChange}
            disabled={disabled}
            className={styles.switchInput}
            name={name}
            data-testid="ios-switch-input"
            {...props}
          />
          <span 
            className={`${styles.switchThumb} ${switchChecked ? styles.checked : ''}`}
            data-testid="ios-switch-thumb"
          />
        </span>
      </label>
      {
        contentModal
      }
    </div>
  );
};

export default DashboardOnvif;